module.exports = __webpack_public_path__ + "media/img/archi-10-5414d320.png";